import { defineMessage } from 'react-intl';

export const fieldRequiredMessage = defineMessage({
  id: 'validation.form.field.required',
  defaultMessage: 'Field is required.',
});

export const fieldNotANumberMessage = defineMessage({
  id: 'validation.form.field.not.a.number',
  defaultMessage: 'Must be an integer.',
});

export const fieldMinLengthMessage = defineMessage({
  id: 'validation.form.field.min.length',
  defaultMessage: 'Must be at least {min} characters.',
});

export const fieldMaxLengthMessage = defineMessage({
  id: 'validation.form.field.max.length',
  defaultMessage: 'Must be less than {max} characters.',
});

export const invalidEmailMessage = defineMessage({
  id: 'validation.form.email.invalid',
  defaultMessage: 'Invalid email address.',
});

export const emailsRequiredMessage = defineMessage({
  id: 'validation.form.emails.required',
  defaultMessage: 'At least one email must be added.',
});

export const dateAfterOtherMessage = defineMessage({
  id: 'validation.form.field.date.is.after.other',
  defaultMessage: 'Start date cannot be after end date.',
});

export const dateBeforeOtherMessage = defineMessage({
  id: 'validation.form.field.date.is.before.other',
  defaultMessage: 'End date cannot be before start date.',
});

export const dateIsValidMessage = defineMessage({
  id: 'validation.form.field.date.is.valid',
  defaultMessage: 'Date is invalid.',
});

export const emailIsInvalidMessage = defineMessage({
  id: 'validation.form.field.email.is.invalid',
  defaultMessage: 'Invalid email address.',
});

export const featureNameExistMessage = defineMessage({
  id: 'validation.form.field.featureName.exist',
  defaultMessage: 'Feature name already exists.',
});

export const fileSizeTooLargeMessage = defineMessage({
  id: 'validation.form.field.fileSize.too.large',
  defaultMessage: 'File size too large.',
});

export const hoursMessage = defineMessage({
  id: 'validation.form.field.hours',
  defaultMessage: 'Must be between 1 and 24 hours.',
});

export const invalidFormatMessage = defineMessage({
  id: 'validation.form.field.invalid.format',
  defaultMessage: 'Invalid format.',
});

export const fieldMaxValueMessage = defineMessage({
  id: 'validation.form.field.max.value',
  defaultMessage: 'Must be less than {max}.',
});

export const millisecondsMinMaxMessage = defineMessage({
  id: 'validation.form.field.milliseconds.minMax',
  defaultMessage: 'Must be greater than 0 and less than 120000.',
});

export const fieldMinValueMessage = defineMessage({
  id: 'validation.form.field.min.value',
  defaultMessage: 'Must be greater than {min}.',
});

export const minutesMessage = defineMessage({
  id: 'validation.form.field.minutes',
  defaultMessage: 'Must be between 1 and 60 minutes.',
});

export const nameExistsMessage = defineMessage({
  id: 'validation.form.field.name.exists',
  defaultMessage: 'Name already exists.',
});

export const numberIsBetweenMessage = defineMessage({
  id: 'validation.form.field.number.is.between',
  defaultMessage: 'Must be between 0 and 10000.',
});

export const numberMinMessage = defineMessage({
  id: 'validation.form.field.number.min',
  defaultMessage: 'Must be greater than {min}.',
});

export const timePeriodTooSmallMessage = defineMessage({
  id: 'validation.form.field.time.period.too.small',
  defaultMessage: 'Delivery profile has larger batching period than simulation.',
});

export const unsupportedFileExtensionMessage = defineMessage({
  id: 'validation.form.field.unsupported.fileExtension',
  defaultMessage: 'File extension is not supported.',
});

export const formValidationMessages = {
  'validation.form.field.required': fieldRequiredMessage,
  'validation.form.field.not.a.number': fieldNotANumberMessage,
  'validation.form.field.min.length': fieldMinLengthMessage,
  'validation.form.field.max.length': fieldMaxLengthMessage,
  'validation.form.email.invalid': invalidEmailMessage,
  'validation.form.emails.required': emailsRequiredMessage,
  'validation.form.field.date.is.after.other': dateAfterOtherMessage,
  'validation.form.field.date.is.before.other': dateBeforeOtherMessage,
  'validation.form.field.date.is.valid': dateIsValidMessage,
  'validation.form.field.email.is.invalid': emailIsInvalidMessage,
  'validation.form.field.featureName.exist': featureNameExistMessage,
  'validation.form.field.fileSize.too.large': fileSizeTooLargeMessage,
  'validation.form.field.hours': hoursMessage,
  'validation.form.field.invalid.format': invalidFormatMessage,
  'validation.form.field.max.value': fieldMaxValueMessage,
  'validation.form.field.milliseconds.minMax': millisecondsMinMaxMessage,
  'validation.form.field.min.value': fieldMinValueMessage,
  'validation.form.field.minutes': minutesMessage,
  'validation.form.field.name.exists': nameExistsMessage,
  'validation.form.field.number.is.between': numberIsBetweenMessage,
  'validation.form.field.number.min': numberMinMessage,
  'validation.form.field.time.period.too.small': timePeriodTooSmallMessage,
  'validation.form.field.unsupported.fileExtension': unsupportedFileExtensionMessage,
};
